export default __webpack_public_path__ + "static/media/discord-logo-white.0a571abe.png";